/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const Modal = ({ children, closeModal }) => (
  <div ref={closeModal} css={styles} className="modal">
    {children}
  </div>
);

const styles = css`
  position: absolute;
  right: 0;
  top: 50px;
  width: 300px;
  background: #30364c;
  @media (max-width: 810px) {
    z-index: 10;
    top: 60px;
  }
`;

export default Modal;
